import { ReviewPagePaging } from "./reviewPagePaging";
import { ReviewPageReviews } from "./ReviewPageReviews";
/** Timestamp string representing the epoch origin, used as a fallback when no date is present. */
const defaultTime = new Date(0, 0, 0).getTime().toString();
/**
 * Sort the reviews inside the given container according to the selected sort type.
 * Resets paging to the first page after sorting.
 * @param reviewContainer The review container element that holds the reviews to be sorted.
 * @param sortType The sort-by dropdown value (e.g. 'latest-review', 'highest-rated').
 */
function sortReviews(reviewContainer, sortType) {
    let reviewsContainer = reviewContainer.querySelector('.reviews-container');
    let reviews = (reviewsContainer !== null && reviewsContainer !== void 0 ? reviewsContainer : reviewContainer).querySelector('.reviews');
    if (reviews == null)
        return;
    let sortField = '';
    let direction = '';
    switch (sortType) {
        case 'latest-review':
            sortField = 'reviewDate';
            direction = 'desc';
            break;
        case 'oldest-review':
            sortField = 'reviewDate';
            direction = 'asc';
            break;
        case 'latest-purchase':
            sortField = 'purchaseDate';
            direction = 'desc';
            break;
        case 'oldest-purchase':
            sortField = 'purchaseDate';
            direction = 'asc';
            break;
        case 'latest-reply':
            sortField = 'replyDate';
            direction = 'desc';
            break;
        case 'oldest-reply':
            sortField = 'replyDate';
            direction = 'asc';
            break;
        case 'highest-rated':
            sortField = 'rating';
            direction = 'desc';
            break;
        case 'lowest-rated':
            sortField = 'rating';
            direction = 'asc';
            break;
        default:
            sortField = 'reviewDate';
            direction = 'desc';
            break;
    }
    let reviewsNodeList = reviews.querySelectorAll('.review');
    let reviewsArray = Array.from(reviewsNodeList);
    reviewsArray = reviewsArray.sort((a, b) => {
        const multiplier = direction === 'asc' ? 1 : -1;
        return (Number(a.dataset[sortField] || defaultTime) - Number(b.dataset[sortField] || defaultTime)) * multiplier;
    });
    const fragment = document.createDocumentFragment();
    reviewsArray.forEach((review) => {
        fragment.appendChild(review);
    });
    reviews.replaceChildren(fragment);
    // Shows the first page of results after Sorting and resets the load more button.
    let loadMoreBtn = null;
    if (reviewsContainer != null)
        loadMoreBtn = reviewsContainer.querySelector('.load-more-button');
    ReviewPagePaging.showHideReviews(reviews.querySelectorAll('.review'), 10, 0, loadMoreBtn);
    if (loadMoreBtn != null)
        loadMoreBtn.dataset['page'] = '0';
}
export class ReviewPageSort {
    /**
     * Attach a change listener to the sort-by dropdown so that reviews are
     * re-sorted and accordions are re-initialised whenever the selection changes.
     * @param reviewContainer The review container element that scopes the sort operation.
     */
    static setupSort(reviewContainer) {
        const sortDropdown = document.querySelector('#sort-by');
        if (sortDropdown == null)
            return;
        sortDropdown.addEventListener('change', () => {
            sortReviews(reviewContainer, sortDropdown.value);
            const reviewAccordians = reviewContainer.querySelectorAll('.review-extras');
            ReviewPageReviews.setupReviewAccordians(reviewAccordians);
        });
    }
}
